/** Paleta do mockup de referência (tempo-eficiencia-mmidd-v40.html), #MMV-2615. */
export const TE_COLORS = {
  bg: "#F6F7FB",
  card: "#FFFFFF",
  border: "#E8EAF1",
  text: "#1A1D29",
  textDim: "#6B7280",
  textFaint: "#98A0B3",
  blue: "#3B6FF2",
  blueBg: "#EAF0FF",
  purple: "#8B5CF6",
  purpleBg: "#F3EDFF",
  orange: "#F2994A",
  orangeBg: "#FEF1E4",
  red: "#EF4444",
  redBg: "#FDEAEA",
  green: "#22A06B",
  greenBg: "#E8F8F1",
  amber: "#EAB308",
  amberBg: "#FEF9E6",
  amberFg: "#A1750A",
} as const;

export const TE_CARD_SX = {
  bgcolor: TE_COLORS.card,
  border: `1px solid ${TE_COLORS.border}`,
  borderRadius: "12px",
  p: 2.25,
} as const;

export const TE_PANEL_TITLE_SX = {
  fontSize: 14,
  fontWeight: 700,
  color: TE_COLORS.text,
} as const;

export const TE_PANEL_DESC_SX = {
  fontSize: 11.5,
  color: TE_COLORS.textDim,
} as const;
